export const PROCESS_NODE_TYPES = ['start', 'end', 'activity', 'decision', 'document', 'process'] as const
export type ProcessNodeType = typeof PROCESS_NODE_TYPES[number]

export interface ProcessGraph {
  nodes: any[]
  edges: any[]
}

export function serializeProcessGraph(nodes: any[], edges: any[]): ProcessGraph {
  return {
    nodes: nodes.map((node) => ({
      id: String(node.id),
      type: PROCESS_NODE_TYPES.includes(node.type) ? node.type : 'activity',
      position: { x: Number(node.position?.x || 0), y: Number(node.position?.y || 0) },
      data: {
        label: String(node.data?.label || '').slice(0, 500),
        linkedId: node.data?.linkedId || null,
      },
    })),
    edges: edges.map((edge) => ({
      id: String(edge.id),
      source: String(edge.source),
      target: String(edge.target),
      sourceHandle: edge.sourceHandle || 'right',
      targetHandle: edge.targetHandle || 'left',
      type: edge.type || 'smoothstep',
      markerEnd: edge.markerEnd || 'arrowclosed',
      data: { label: String(edge.data?.label || edge.label || '').slice(0, 500) },
      label: String(edge.data?.label || edge.label || '').slice(0, 500),
    })),
  }
}

export function validateProcessGraph(graph: ProcessGraph): string[] {
  const errors: string[] = []
  const ids = graph.nodes.map((node) => node.id)
  if (new Set(ids).size !== ids.length) errors.push('duplicate_nodes')
  graph.nodes.forEach((node) => {
    if (!PROCESS_NODE_TYPES.includes(node.type)) errors.push('invalid_node_type')
    if (!Number.isFinite(node.position?.x) || !Number.isFinite(node.position?.y)) errors.push('invalid_position')
    if (node.type === 'process' && !node.data?.linkedId) errors.push('invalid_linked_process')
  })
  const edgeIds = graph.edges.map((edge) => edge.id)
  if (new Set(edgeIds).size !== edgeIds.length) errors.push('duplicate_edges')
  graph.edges.forEach((edge) => {
    if (!edge.id || !ids.includes(edge.source) || !ids.includes(edge.target)) errors.push('invalid_edge')
  })
  return [...new Set(errors)]
}

export function cloneProcessGraph(graph: ProcessGraph): ProcessGraph {
  const cloned = JSON.parse(JSON.stringify(graph))
  cloned.edges = (cloned.edges || []).map((edge: any) => ({
    ...edge,
    sourceHandle: edge.sourceHandle || 'right',
    targetHandle: edge.targetHandle || 'left',
  }))
  return cloned
}
